export interface LeadFormAnswer {
  key: string;
  question: string;
  values: string[];
}

const approvedKeys = new Set(['heating_system', 'service', 'product', 'installation_timing', 'start_timing', 'decision_timing', 'timeframe']);

/** Defensive read boundary for old releases, empty captures and malformed data. */
export function parseLeadFormAnswers(raw: unknown): LeadFormAnswer[] {
  if (!Array.isArray(raw)) return [];
  const seen = new Set<string>();
  return raw.slice(0, 10).flatMap((item: unknown) => {
    if (!item || typeof item !== 'object') return [];
    const { key, question, values } = item as Record<string, unknown>;
    if (typeof key !== 'string' || !approvedKeys.has(key) || seen.has(key)
      || typeof question !== 'string' || !question.trim() || !Array.isArray(values)) return [];
    const safeValues = [...new Set(values.filter((value): value is string => typeof value === 'string')
      .slice(0, 8).map(value => value.trim().slice(0, 300)).filter(Boolean))];
    if (!safeValues.length) return [];
    seen.add(key);
    return [{ key, question: question.slice(0, 300), values: safeValues }];
  });
}

export function customerTimeframeAnswer(answers: LeadFormAnswer[] | undefined): string | undefined {
  return answers?.find(answer => ['installation_timing', 'start_timing', 'decision_timing', 'timeframe'].includes(answer.key))?.values.join(' · ');
}
